import { useEffect } from "react";

// SEO côté client (CRA, pas de SSR) : met à jour <title>, meta description,
// canonical, Open Graph, Twitter et un bloc JSON-LD. Restaure les valeurs par
// défaut au démontage pour éviter des métadonnées obsolètes lors de la navigation.

const SITE = "https://gestimmony.fr";
const DEFAULT_TITLE = "Gestimmony — Logiciel de gestion locative pour propriétaires bailleurs";
const DEFAULT_DESC = "Quittances automatiques, suivi des loyers, déclaration 2044 : gérez vos locations sans Excel. Sans engagement en mensuel.";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function Seo({ title, description, path = "/", image, type = "website", jsonLd }) {
  const ld = jsonLd ? JSON.stringify(jsonLd) : null;
  useEffect(() => {
    const url = SITE + path;
    const t = title || DEFAULT_TITLE;
    const d = description || DEFAULT_DESC;
    const img = image || `${SITE}/og-image.png`;

    document.title = t;
    upsertMeta("name", "description", d);
    upsertLink("canonical", url);
    upsertMeta("property", "og:title", t);
    upsertMeta("property", "og:description", d);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", img);
    upsertMeta("property", "og:type", type);
    upsertMeta("name", "twitter:title", t);
    upsertMeta("name", "twitter:description", d);
    upsertMeta("name", "twitter:image", img);

    let script = document.getElementById("ld-json-page");
    if (ld) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "ld-json-page";
        document.head.appendChild(script);
      }
      script.textContent = ld;
    } else if (script) {
      script.remove();
    }

    return () => {
      document.title = DEFAULT_TITLE;
      upsertMeta("name", "description", DEFAULT_DESC);
      upsertLink("canonical", `${SITE}/`);
      upsertMeta("property", "og:title", DEFAULT_TITLE);
      upsertMeta("property", "og:description", DEFAULT_DESC);
      upsertMeta("property", "og:url", `${SITE}/`);
      upsertMeta("property", "og:image", `${SITE}/og-image.png`);
      upsertMeta("property", "og:type", "website");
      const s = document.getElementById("ld-json-page");
      if (s) s.remove();
    };
  }, [title, description, path, image, type, ld]);

  return null;
}

export default Seo;
